import script from "./AddCheckPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCheckPoints.vue?vue&type=script&setup=true&lang=js"

import "./AddCheckPoints.vue?vue&type=style&index=0&id=3dfd9f09&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dfd9f09"]])

export default __exports__